import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    background: "rgba(0, 0, 0, 0.80)",
    backdropFilter: "blur(5px)",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    top: 0,
    position: "fixed",
    zIndex: theme.zIndex.dialog,
  },
  service: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    marginTop: 90,
    padding: `0 ${theme.spacing.space16}px`,
    justifyContent: "space-between",
  },
  rowService: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  launchpads: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 16,
  },
  forwardsAnimate: {
    animation: `$forwardsAnimate 0.3s ease-in forwards`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  backwardsAnimate: {
    animation: `$backwardsAnimate 0.3s ease-in forwards`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  icon: {
    color: theme.colors.Background7,
  },
  "@keyframes forwardsAnimate": {
    "0%": {
      transform: "translateY(-100%)",
    },
    "100%": {
      transform: "translateY(0%)",
    },
  },
  "@keyframes backwardsAnimate": {
    "0%": {
      transform: "translateY(0%)",
    },
    "100%": {
      transform: "translateY(-100%)",
    },
  },
}));
